const PaymentActionTypes = {
    FETCH_PAYMENTS_START: "FETCH_ADMIN_PAYMENTS_START",
    SET_TOTAL_PAYMENTS: "SET_TOTAL_PAYMENTS",
    FETCH_PAYMENTS_SUCCESS: "FETCH_ADMIN_PAYMENTS_SUCCESS",
    FETCH_PAYMENTS_FAILURE: "FETCH_ADMIN_PAYMENTS_FAILURE",
};

export default PaymentActionTypes;
